import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { Spinner } from 'triider-components';

import { Creators as TaskCreators } from 'store/ducks/task';

import reportProblemIcon from 'assets/img/reportar-problema.svg';
import ReportModal from '../OrderModals/ReportModal';

import { gaSendEvent } from '../../../../utils/analytics';

import {
  Container,
  Img,
  Title,
  Description,
  Button,
  Problems,
  CardProblem,
  Row,
  RowTitle,
  RowSubtitle,
} from './styles';

const ReportTab = ({
  loadingVisible,
  reasons,
  problems,
  task,
  reportProblemSuccess,
  _getReasons,
  _getProblems,
  _reportProblem,
  _reportProblemSuccess,
}) => {
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    if (task.id) _getProblems(task.id);

    _getReasons();
  }, [task]);

  useEffect(() => {
    if (reportProblemSuccess) {
      setModalVisible(false);
      _reportProblemSuccess({ success: false });
    }
  }, [reportProblemSuccess]);

  const sendProblem = (feedback) => {
    _reportProblem({ task_id: task.id, feedback });
  };

  const reportProblem = () => {
    gaSendEvent('reportar_problema', 'detalhes_pedido');
    setModalVisible(true);
  };

  return (
    <Container>
      {loadingVisible ? (
        <Spinner size="larger" />
      ) : (
        <Fragment>
          <ReportModal
            reasons={reasons}
            onFinish={sendProblem}
            isOpen={modalVisible}
            close={() => setModalVisible(false)}
          />
          {!problems.length ? (
            <Fragment>
              <Img src={reportProblemIcon} alt="Reportar Problema" />
              <Title>Ficou com dúvida ou tem algum problema?</Title>
              <Description>
                Estamos aqui para te ajudar! Entre em contato com a gente pelo chat ao lado ou
                reporte um problema.
              </Description>
            </Fragment>
          ) : (
            <Problems>
              {problems.map(p => (
                <CardProblem key={`problem-${p.id}`}>
                  <Row>
                    <RowTitle>PROBLEMA REPORTADO:</RowTitle>
                    <RowSubtitle>{p.feedback_text}</RowSubtitle>
                  </Row>
                  <Row>
                    <RowTitle>DATA DO REPORTE DO PROBLEMA:</RowTitle>
                    <RowSubtitle>
                      {`${moment(p.created).format('DD/MM/YYYY')} - ${moment(p.created).format(
                        'HH:mm:ss',
                      )}h`}
                    </RowSubtitle>
                  </Row>
                  {!!p.comments && (
                    <Row>
                      <RowTitle>DETALHES:</RowTitle>
                      <RowSubtitle>{p.comments}</RowSubtitle>
                    </Row>
                  )}
                </CardProblem>
              ))}
            </Problems>
          )}
          <Button onClick={() => reportProblem()}>Reportar problema</Button>
        </Fragment>
      )}
    </Container>
  );
};

const mapStateToProps = state => ({
  problems: state.task.reportProblem.problems,
  reasons: state.task.reportProblem.reasons,
  reportProblemSuccess: state.task.reportProblem.success,
  task: state.task.taskDetail,
  loadingVisible: state.ui.loaders.includes('REPORT_PROBLEM'),
});

const mapDispatchToProps = {
  _getProblems: TaskCreators.getReportProblemsRequest,
  _getReasons: TaskCreators.reportProblemReasonsRequest,
  _reportProblem: TaskCreators.reportProblemRequest,
  _reportProblemSuccess: TaskCreators.reportProblemSuccess,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportTab);
